// extracted by mini-css-extract-plugin
module.exports = {"root":"ImageSlider_root__14tlc","thumb":"ImageSlider_thumb__286WE","selected":"ImageSlider_selected__26tWY","album":"ImageSlider_album__MvpcW"};